import { createSlice } from '@reduxjs/toolkit';

import { fetchAssessmentAgreement } from 'redux/assessment-agreement/assessment_agreement.middleware';
import { logout } from 'redux/auth/auth-middleware';
import type { AgreementSummary } from 'types';

type AssessmentAgreementState = {
    file: Blob | null;
    summary: AgreementSummary | null;
    error: string | null;
    isLoading: boolean;
};

const initialState: AssessmentAgreementState = {
    file: null,
    summary: null,
    error: null,
    isLoading: false,
};

export const assessmentAgreementSlice = createSlice({
    name: 'app/assessment-agreement',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAssessmentAgreement.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchAssessmentAgreement.fulfilled, (state, action) => {
                state.file = action.payload.file;
                state.summary = action.payload.summary;
                state.isLoading = false;
            })
            .addCase(fetchAssessmentAgreement.rejected, (state, action) => {
                state.error = action.error.message || 'Failed to load agreement';
                state.isLoading = false;
            })
            .addCase(logout.fulfilled, () => initialState);
    },
});

export default assessmentAgreementSlice.reducer;
